import { useState } from "react";
import { Eye } from "lucide-react";

interface MaskedValueProps {
  /** The actual (unmasked) value */
  originalValue: string;
  /** A unique key identifying this field for unmask tracking (e.g. "row-3-email") */
  unmaskKey: string;
  /** Descriptive name for audit logging (e.g. "email") */
  fieldName?: string;
  /** Whether this value is currently unmasked */
  isUnmasked: boolean;
  /** Function to request unmasking — returns true if allowed */
  onRequestUnmask: (key: string, fieldName?: string) => Promise<boolean>;
  /** Optional class name */
  className?: string;
}

const MASK_CHAR = "●●●●●●";

const MaskedValue = ({
  originalValue,
  unmaskKey,
  fieldName,
  isUnmasked,
  onRequestUnmask,
  className,
}: MaskedValueProps) => {
  const [revealing, setRevealing] = useState(false);

  if (isUnmasked) {
    return <span className={className}>{originalValue}</span>;
  }

  const handleClick = async () => {
    if (revealing) return;
    setRevealing(true);
    await onRequestUnmask(unmaskKey, fieldName);
    setRevealing(false);
  };

  return (
    <span
      className={`inline-flex items-center gap-1 cursor-pointer group/mask ${className ?? ""}`}
      onClick={handleClick}
      title="Click to unmask"
    >
      <span className="select-none">{MASK_CHAR}</span>
      <Eye className="h-3 w-3 text-muted-foreground opacity-0 group-hover/mask:opacity-100 transition-opacity shrink-0" />
    </span>
  );
};

export default MaskedValue;
